import script from "./PropertyDetailContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./PropertyDetailContent.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__